var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var AbortController = require('abort-controller');

var retimer = require('retimer');

var TimeoutController = /*#__PURE__*/function (_AbortController) {
  "use strict";

  _inherits(TimeoutController, _AbortController);

  var _super = _createSuper(TimeoutController);

  /**
   * @constructor
   * @param {number} ms milliseconds
   */
  function TimeoutController(ms) {
    var _this;

    _classCallCheck(this, TimeoutController);

    _this = _super.call(this);
    _this._ms = ms;
    _this._timer = retimer(function () {
      return _this.abort();
    }, ms);
    return _this;
  }
  /**
   * Aborts the controller and clears the timer
   */


  _createClass(TimeoutController, [{
    key: "abort",
    value: function abort() {
      this._timer.clear();

      return _get(_getPrototypeOf(TimeoutController.prototype), "abort", this).call(this);
    }
    /**
     * Clears the timer
     */

  }, {
    key: "clear",
    value: function clear() {
      this._timer.clear();
    }
    /**
     * Resets the timer
     */

  }, {
    key: "reset",
    value: function reset() {
      var _this2 = this;

      this._timer.clear();

      this._timer = retimer(function () {
        return _this2.abort();
      }, this._ms);
    }
  }]);

  return TimeoutController;
}(AbortController);

module.exports = TimeoutController;
module.exports.TimeoutController = TimeoutController;